var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "Fullscreen",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>icon_library</title>
  <g id="svg-fg">
    <path d="M44.39,15.63H37.75A1.33,1.33,0,0,0,36.43,17v1.77a1.33,1.33,0,0,0,1.33,1.33h6.2v6.2a1.33,1.33,0,0,0,1.33,1.33H47a1.33,1.33,0,0,0,1.33-1.33V19.61A4,4,0,0,0,44.39,15.63Z"/>
    <path d="M47,36.43H45.28a1.33,1.33,0,0,0-1.33,1.33v6.2h-6.2a1.33,1.33,0,0,0-1.33,1.33V47a1.33,1.33,0,0,0,1.33,1.33h6.64a4,4,0,0,0,4-4V37.75A1.33,1.33,0,0,0,47,36.43Z"/>
    <path d="M26.25,43.95h-6.2v-6.2a1.33,1.33,0,0,0-1.33-1.33H17a1.33,1.33,0,0,0-1.33,1.33v6.64a4,4,0,0,0,4,4h6.64A1.33,1.33,0,0,0,27.57,47V45.28A1.33,1.33,0,0,0,26.25,43.95Z"/>
    <path d="M26.25,15.63H19.61a4,4,0,0,0-4,4v6.64A1.33,1.33,0,0,0,17,27.57h1.77a1.33,1.33,0,0,0,1.33-1.33v-6.2h6.2a1.33,1.33,0,0,0,1.33-1.33V17A1.33,1.33,0,0,0,26.25,15.63Z"/>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/assets/icons/fullscreen.svg